module.exports = __webpack_public_path__ + "static/media/0.632c8e17.jpg";